import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';

export default function StackedInput({ className, ...props }) {
  return (
    <input className={classnames(styles.stackedInput, className)} {...props} />
  );
}
